/* @flow */

import React from "react";
import cn from "classnames";
import { useHistory } from "react-router";
import { useData } from "crustate/react";
import { QuoteData } from "state/data";
import CartIcon from "icons/cart.svg";
import { useTranslate } from "@awardit/react-use-translate";
import { Button } from "@crossroads/ui-components";

import styles from "./styles.scss";

type Props = {
  className: string,
  isOpen: boolean,
  openMiniCart: () => void,
};

const CartCounter = ({ className = "", isOpen, openMiniCart }: Props): React$Node => {
  const data = useData(QuoteData);
  const history = useHistory();
  const t = useTranslate();
  const onCheckoutCart = history.location.pathname.includes(t("URL.CHECKOUT_CART"));
  const onCheckoutOverview = history.location.pathname.includes(t("URL.CHECKOUT_OVERVIEW"));
  const cartCount =
    data.data ?
      data.data.items.reduce((a, { qty }) => a + qty, 0) :
      0;

  if (cartCount > 0) {
    return (
      <Button
        type="button"
        aria-controls="cartMini"
        aria-expanded={isOpen ?? "false"}
        className={cn(
          styles.cartCounter,
          { [styles.active]: onCheckoutCart || onCheckoutOverview || isOpen },
          className
        )}
        onClick={() => {
          if (onCheckoutCart) {
            history.go(0);
          }
          else if (onCheckoutOverview) {
            history.push(t("URL.CHECKOUT_CART"));
          }
          else if (cartCount) {
            openMiniCart();
          }
        }}
      >
        <div>
          <span className={styles.count}>
            {cartCount}
          </span>
          <CartIcon aria-label={t("ICONS.CART")} className={styles.icon} />
        </div>
      </Button>
    );
  }

  return (
    <div className={cn(styles.cartCounter, className)}>
      <CartIcon aria-label={t("ICONS.CART")} />
    </div>
  );
};

export default CartCounter;
